import { useMemo } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { getLabelMessage } from '@gef-ui/localization/messages';

import Dialog from 'app/components/MaterialDialog';
import Version from 'components/atoms/Version';
import PAGES from 'constants/pages';
import { templateTypes } from 'features/views/campaignSettings/templates/constants';

import LoadSaveTemplateModalBody from './LoadSaveTemplateModalBody';

const LoadSaveTemplateModal = NiceModal.create((props) => {
	const modal = useModal();

	const modalInfo = useMemo(() => {
		const info = {};

		if (props.type === templateTypes.SAVE) {
			info.title = getLabelMessage('templates:titleSave');
			info.screenId = PAGES.campaignSettings.saveTemplateModal.id;
			info.screenName = PAGES.campaignSettings.saveTemplateModal.name;
		} else {
			info.title = getLabelMessage('templates:titleRead');
			info.screenId = PAGES.campaignSettings.loadTemplateModal.id;
			info.screenName = PAGES.campaignSettings.loadTemplateModal.name;
		}
		return info;
	}, [props.type]);

	return (
		<Dialog
			modal={modal}
			title={modalInfo.title}
			content={<LoadSaveTemplateModalBody {...props} />}
			maxWidth="lg"
			version={<Version screenId={modalInfo.screenId} screenName={modalInfo.screenName} />}
		/>
	);
});

export default LoadSaveTemplateModal;
